import { IPhotoEntityReference } from '../basic';

export interface IPage {
  /** Key of the page */
  key: string;
  /** Name to identify the page as a human */
  name: string;
  /** Unique id */
  pageID: number;
  /** URL to access the page */
  url: string;
  /** Title for the browser of the page */
  title: string;
  /** Picture wich is rarely set */
  picture?: IPhotoEntityReference;
  /** Type of the page */
  type: PageType;
  /** The date when this page got created */
  createdOn: Date;
  /** Last change of the page (backend or designer) */
  modifiedOn?: Date;
}

/** Columns the page list (`f/pages`) can be sorted by, named like the backend fields */
export type PageSortColumn = 'Name' | 'Url' | 'Key' | 'CreatedOn' | 'ModifiedOn';

/**
 * Enumeration of different page types
 * - Page: Regular page // Default for websites
 * - Plugin: Page belonging to an app (e.g. loyalty)
 * - LocalSeo: Local SEO landing page
 * - CloudFront: Page served by the CloudFront (Cloud Software 4) frontend
 */
export enum PageType {
  Page = 0,
  Plugin = 1,
  LocalSeo = 2,
  CloudFront = 3,
}

/**
 * Enumeration of the publication states of a page
 * - Published: Page is live
 * - Draft: Page is not published yet
 * - Plugin: Page belongs to an app/plugin
 */
export enum PageStatusType {
  Published = 0,
  Draft = 1,
  Plugin = 2
}

/**
 * A page as returned by the page select endpoint (`f/select/pages`).
 * Mirrors the backend `PageItem` and therefore differs from {@link IPage}.
 */
export interface IPageSelectItem {
  /** Unique id of the page */
  iD: number;
  /** Title of the page in the session language */
  title?: string;
  /** Name of the page in the session language */
  subTitle?: string;
  /** URL of the page in the session language */
  url?: string;
  /** Key of the page */
  key?: string;
  /** Type of the page */
  type: PageType;
  /** Does the page have sub pages? */
  hasChildren?: boolean;
}
